import React from "react";
import { useIsMobile } from "@/app/redux/features/device/selectors";
import { FEATURED_COMPETITION_BG_COLOUR, FEATURED_COMPETITION_ENDS_TEXT_COLOUR } from "./header-constants";
import { useCompetitionByType } from "../../redux/features/categories/selectors";
import { getEndsInLabel } from "../../../helpers/endsIn";

const SubscriberCompetitionsWidget = () => {
  const isMobile = useIsMobile();
  const subscriberCompetitions = useCompetitionByType("subscriberCompetitions");
  if (!subscriberCompetitions?.competitions?.length) {
    return null;
  }
  const firstCompetition = subscriberCompetitions.competitions[0];
  return (
    <>
      <div className={"font-jost"}>
        <div className={"text-gray-1 text-xs font-medium leading-4 lg:text-sm lg:leading-5 uppercase"}>
          Pass member exclusives
        </div>
        <div className={"bg-white rounded-lg lg:rounded-2xl mt-3 lg:mt-4"}>
          <div className={"w-full h-[68px] lg:h-[81px] relative"}>
            <img
              src={`/assets/images/menu/subscriber-competitions/${isMobile ? "banner-m.webp" : "banner-d.webp"}`}
              alt={"Subscriber Competitions Banner"}
              width={400}
              height={81}
              className="rounded-t-lg lg:rounded-t-2xl object-cover size-full"
            />
            <div
              className={
                "absolute left-5 top-1/2 -translate-y-1/2 max-w-24 text-white font-jost text-base font-medium leading-5.5"
              }>
              Subscriber Competitions
            </div>
          </div>

          <div className={"py-5 lg:pt-[36px] lg:pb-6 px-3 lg:px-5 flex flex-col items-center"}>
            <div className={"flex flex-col items-center gap-6 w-full mb-4 lg:mb-5"}>
              <div
                onClick={() => (location.href = firstCompetition.PageUrl)}
                className={"flex items-center w-full cursor-pointer"}>
                <div
                  className={`rounded-sm ${FEATURED_COMPETITION_BG_COLOUR[firstCompetition.NavigationColour as keyof typeof FEATURED_COMPETITION_BG_COLOUR]} h-12 w-1 mr-1 lg:h-14`}></div>

                <div className={"mr-2.5 rounded"}>
                  <img
                    src={firstCompetition.ImageUrl}
                    alt={"Featured Competitions Image"}
                    width={96}
                    height={96}
                    className="object-cover size-12 rounded lg:size-14"
                  />
                </div>

                <div className={"flex flex-col justify-center gap-1"}>
                  <div
                    className={
                      "text-dark-1 max-w-40 font-jost text-sm font-medium leading-4 uppercase lg:text-base lg:leading-5"
                    }>
                    {firstCompetition.Title} {firstCompetition.AdditionalCashText}
                  </div>
                  <div
                    className={`font-jost text-xs font-medium leading-4 ${FEATURED_COMPETITION_ENDS_TEXT_COLOUR[firstCompetition.NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_COLOUR]}`}>
                    Ends {getEndsInLabel(firstCompetition.EndDate)}
                  </div>
                </div>

                <div
                  className={
                    "uppercase bg-[#EEEEEF] ml-auto rounded-lg text-center py-1 px-2.5 text-nav-azure font-jost text-xs font-medium h-8 flex-center"
                  }>
                  Enter
                </div>
              </div>
            </div>

            <div
              onClick={() => (location.href = "/subscriber-competitions")}
              className={"mt-auto flex items-center text-nav-azure cursor-pointer"}>
              <span className={"font-jost text-[13px] font-medium leading-4.5"}>
                VIEW ALL ({subscriberCompetitions.competitions.length})
              </span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.33325 5.83334L12.4999 10L8.33325 14.1667"
                  stroke="#3772FF"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriberCompetitionsWidget;
